import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { StoreService } from 'app/ngrx/store.service';
import { hasProfile } from 'app/shared/utils';

@Injectable({ providedIn: 'root' })
export class NotSupervisorGuard implements CanActivate, CanLoad {
  constructor(
    private readonly router: Router,
    private readonly storeService: StoreService
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean | UrlTree {
    return this.checkAccess();
  }

  canLoad(_route: Route, _segments: UrlSegment[]): boolean | UrlTree {
    return this.checkAccess();
  }

  private checkAccess(): boolean | UrlTree {
    return this.isSupervisor()
      ? this.router.parseUrl('/forbidden-access')
      : true;
  }

  private isSupervisor(): boolean {
    if (hasProfile(this.storeService.getConnectedUser(), ['Superviseur'])) {
      return true;
    }

    const token = localStorage.getItem('accessToken');
    if (!token) {
      return false;
    }

    try {
      const decodedToken = new JwtHelperService().decodeToken(token);
      const roleClaim = decodedToken?.role
        ?? decodedToken?.['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
      const roles = Array.isArray(roleClaim) ? roleClaim : [roleClaim];
      return roles.includes('Superviseur');
    } catch {
      return false;
    }
  }
}
